import React from "react";
import Seo from "../components/Seo";
import Footer from "../components/Footer";
import RecruitList from "../components/RecruitList";
import Hero from "../components/Heros/HeroRecruit";

const RecruitNotice = () => (
    <>
        <Seo
            title="채용공고"
            description="KUSRC와 함께 할 멋진 동료를 찾고 있습니다. 진행 중인 채용 공고를 확인해 보세요."
            path="/recruit/jobs"
        />
        <Hero/>
        <RecruitList />    
        <Footer />
    </>
);

export default RecruitNotice;
